module.exports = __webpack_public_path__ + "img/vrart_balloon3_sp.60debf81.svg";